module.exports = __webpack_public_path__ + "media/dogs/puppy-and-great-dane-with-plus-sign-709edd4b.svg";